import {NgModule,EventEmitter,Directive,ViewContainerRef,Input,Output,ContentChildren,ContentChild,TemplateRef,OnInit,OnChanges,OnDestroy,AfterContentInit,QueryList,SimpleChanges,EmbeddedViewRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
export class Header {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-header',
    template: '<ng-content></ng-content>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Header_tsickle_Closure_declarations() {
/** @type {?} */
Header.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Header.ctorParameters;
}

export class Footer {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-footer',
    template: '<ng-content></ng-content>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Footer_tsickle_Closure_declarations() {
/** @type {?} */
Footer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Footer.ctorParameters;
}

export class PrimeTemplate {
    
     type: string;
    
     name: string;
/**
 * @param {?} template
 */
constructor(public template: TemplateRef<any>) {}
/**
 * @return {?}
 */
getType(): string {
        return this.name;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[pTemplate]',
    host: {
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'name': [{ type: Input, args: ['pTemplate', ] },],
};
}

function PrimeTemplate_tsickle_Closure_declarations() {
/** @type {?} */
PrimeTemplate.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PrimeTemplate.ctorParameters;
/** @type {?} */
PrimeTemplate.propDecorators;
/** @type {?} */
PrimeTemplate.prototype.type;
/** @type {?} */
PrimeTemplate.prototype.name;
/** @type {?} */
PrimeTemplate.prototype.template;
}

export class TemplateWrapper implements OnInit, OnDestroy {
    
     item: any;
    
     index: number;
    
     templateRef: TemplateRef<any>;
    
    view: EmbeddedViewRef<any>;
/**
 * @param {?} viewContainer
 */
constructor(public viewContainer: ViewContainerRef) {}
/**
 * @return {?}
 */
ngOnInit() {
        this.view = this.viewContainer.createEmbeddedView(this.templateRef, {
            '\$implicit': this.item,
            'index': this.index
        });
    }
/**
 * @return {?}
 */
ngOnDestroy() {
		this.view.destroy();
	}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[pTemplateWrapper]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input },],
'index': [{ type: Input },],
'templateRef': [{ type: Input, args: ['pTemplateWrapper', ] },],
};
}

function TemplateWrapper_tsickle_Closure_declarations() {
/** @type {?} */
TemplateWrapper.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TemplateWrapper.ctorParameters;
/** @type {?} */
TemplateWrapper.propDecorators;
/** @type {?} */
TemplateWrapper.prototype.item;
/** @type {?} */
TemplateWrapper.prototype.index;
/** @type {?} */
TemplateWrapper.prototype.templateRef;
/** @type {?} */
TemplateWrapper.prototype.view;
/** @type {?} */
TemplateWrapper.prototype.viewContainer;
}

export class Column implements AfterContentInit{
     field: string;
     colId: string;
     sortField: string;
     filterField: string;
     header: string;
     footer: string;
     sortable: any;
     editable: boolean;
     filter: boolean;
     filterMatchMode: string;
     filterType: string = 'text';
     excludeGlobalFilter: boolean;
     rowspan: number;
     colspan: number;
     scope: string;
     style: any;
     styleClass: string;
     exportable: boolean = true;
     headerStyle: any;
     headerStyleClass: string;
     bodyStyle: any;
     bodyStyleClass: string;
     footerStyle: any;
     footerStyleClass: string;
     hidden: boolean;
     expander: boolean;
     selectionMode: string;
     filterPlaceholder: string;
     filterMaxlength: number;
     frozen: boolean;
     resizable: boolean = true;
     sortFunction: EventEmitter<any> = new EventEmitter();
     templates: QueryList<any>;
     template: TemplateRef<any>;
public headerTemplate: TemplateRef<any>;
public bodyTemplate: TemplateRef<any>;
public footerTemplate: TemplateRef<any>;
public filterTemplate: TemplateRef<any>;
public editorTemplate: TemplateRef<any>;
/**
 * @return {?}
 */
ngAfterContentInit():void {
        this.templates.forEach((item) => {
            switch(item.getType()) {
                case 'header':
                    this.headerTemplate = item.template;
                break;
                
                case 'body':
                    this.bodyTemplate = item.template;
                break;
                
                case 'footer':
                    this.footerTemplate = item.template;
                break;
                
                case 'filter':
                    this.filterTemplate = item.template;
                break;
                
                case 'editor':
                    this.editorTemplate = item.template;
                break;
                
                default:
                    this.bodyTemplate = item.template;
                break;
            }
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-column',
    template: ''
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'field': [{ type: Input },],
'colId': [{ type: Input },],
'sortField': [{ type: Input },],
'filterField': [{ type: Input },],
'header': [{ type: Input },],
'footer': [{ type: Input },],
'sortable': [{ type: Input },],
'editable': [{ type: Input },],
'filter': [{ type: Input },],
'filterMatchMode': [{ type: Input },],
'filterType': [{ type: Input },],
'excludeGlobalFilter': [{ type: Input },],
'rowspan': [{ type: Input },],
'colspan': [{ type: Input },],
'scope': [{ type: Input },],
'style': [{ type: Input },],
'styleClass': [{ type: Input },],
'exportable': [{ type: Input },],
'headerStyle': [{ type: Input },],
'headerStyleClass': [{ type: Input },],
'bodyStyle': [{ type: Input },],
'bodyStyleClass': [{ type: Input },],
'footerStyle': [{ type: Input },],
'footerStyleClass': [{ type: Input },],
'hidden': [{ type: Input },],
'expander': [{ type: Input },],
'selectionMode': [{ type: Input },],
'filterPlaceholder': [{ type: Input },],
'filterMaxlength': [{ type: Input },],
'frozen': [{ type: Input },],
'resizable': [{ type: Input },],
'sortFunction': [{ type: Output },],
'templates': [{ type: ContentChildren, args: [PrimeTemplate, ] },],
'template': [{ type: ContentChild, args: [TemplateRef, ] },],
};
}

function Column_tsickle_Closure_declarations() {
/** @type {?} */
Column.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Column.ctorParameters;
/** @type {?} */
Column.propDecorators;
/** @type {?} */
Column.prototype.field;
/** @type {?} */
Column.prototype.colId;
/** @type {?} */
Column.prototype.sortField;
/** @type {?} */
Column.prototype.filterField;
/** @type {?} */
Column.prototype.header;
/** @type {?} */
Column.prototype.footer;
/** @type {?} */
Column.prototype.sortable;
/** @type {?} */
Column.prototype.editable;
/** @type {?} */
Column.prototype.filter;
/** @type {?} */
Column.prototype.filterMatchMode;
/** @type {?} */
Column.prototype.filterType;
/** @type {?} */
Column.prototype.excludeGlobalFilter;
/** @type {?} */
Column.prototype.rowspan;
/** @type {?} */
Column.prototype.colspan;
/** @type {?} */
Column.prototype.scope;
/** @type {?} */
Column.prototype.style;
/** @type {?} */
Column.prototype.styleClass;
/** @type {?} */
Column.prototype.exportable;
/** @type {?} */
Column.prototype.headerStyle;
/** @type {?} */
Column.prototype.headerStyleClass;
/** @type {?} */
Column.prototype.bodyStyle;
/** @type {?} */
Column.prototype.bodyStyleClass;
/** @type {?} */
Column.prototype.footerStyle;
/** @type {?} */
Column.prototype.footerStyleClass;
/** @type {?} */
Column.prototype.hidden;
/** @type {?} */
Column.prototype.expander;
/** @type {?} */
Column.prototype.selectionMode;
/** @type {?} */
Column.prototype.filterPlaceholder;
/** @type {?} */
Column.prototype.filterMaxlength;
/** @type {?} */
Column.prototype.frozen;
/** @type {?} */
Column.prototype.resizable;
/** @type {?} */
Column.prototype.sortFunction;
/** @type {?} */
Column.prototype.templates;
/** @type {?} */
Column.prototype.template;
/** @type {?} */
Column.prototype.headerTemplate;
/** @type {?} */
Column.prototype.bodyTemplate;
/** @type {?} */
Column.prototype.footerTemplate;
/** @type {?} */
Column.prototype.filterTemplate;
/** @type {?} */
Column.prototype.editorTemplate;
}

export class Row {
    
     columns: QueryList<Column>;
    
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-row',
    template: ``
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'columns': [{ type: ContentChildren, args: [Column, ] },],
};
}

function Row_tsickle_Closure_declarations() {
/** @type {?} */
Row.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Row.ctorParameters;
/** @type {?} */
Row.propDecorators;
/** @type {?} */
Row.prototype.columns;
}

export class HeaderColumnGroup {
    
     frozen: boolean;
        
     rows: QueryList<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-headerColumnGroup',
    template: ``
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'frozen': [{ type: Input },],
'rows': [{ type: ContentChildren, args: [Row, ] },],
};
}

function HeaderColumnGroup_tsickle_Closure_declarations() {
/** @type {?} */
HeaderColumnGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderColumnGroup.ctorParameters;
/** @type {?} */
HeaderColumnGroup.propDecorators;
/** @type {?} */
HeaderColumnGroup.prototype.frozen;
/** @type {?} */
HeaderColumnGroup.prototype.rows;
}

export class FooterColumnGroup {
        
     frozen: boolean;
        
     rows: QueryList<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-footerColumnGroup',
    template: ``
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'frozen': [{ type: Input },],
'rows': [{ type: ContentChildren, args: [Row, ] },],
};
}

function FooterColumnGroup_tsickle_Closure_declarations() {
/** @type {?} */
FooterColumnGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FooterColumnGroup.ctorParameters;
/** @type {?} */
FooterColumnGroup.propDecorators;
/** @type {?} */
FooterColumnGroup.prototype.frozen;
/** @type {?} */
FooterColumnGroup.prototype.rows;
}

export class PrimeNGSharedModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [Header,Footer,Column,PrimeTemplate,Row,HeaderColumnGroup,FooterColumnGroup, TemplateWrapper],
    declarations: [Header,Footer,Column,PrimeTemplate,Row,HeaderColumnGroup,FooterColumnGroup, TemplateWrapper]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PrimeNGSharedModule_tsickle_Closure_declarations() {
/** @type {?} */
PrimeNGSharedModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PrimeNGSharedModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
